export default "__VITE_ASSET__DH2Rf5DQ__"